export default __webpack_public_path__ + "static/media/27-ART-(2-1).342b0a8a.jpg";